var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16772,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7997 17.1112V20.9512C21.7995 21.4945 21.5835 22.0155 21.1993 22.3997C20.8152 22.7839 20.2942 22.9998 19.7509 23H9.7177C9.44765 22.9999 9.18029 22.9464 8.93097 22.8427C8.68165 22.7389 8.4553 22.5869 8.26491 22.3954C8.07452 22.2039 7.92385 21.9766 7.82156 21.7267C7.71927 21.4768 7.66738 21.2091 7.66886 20.9391V10.9172C7.66725 10.6475 7.71917 10.3803 7.82161 10.1309C7.92405 9.88148 8.07497 9.65488 8.26562 9.46423C8.45627 9.27358 8.68287 9.12266 8.93228 9.02022C9.18168 8.91778 9.44894 8.86586 9.71856 8.86747H13.5576",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7997 12.4011L18.2668 8.86734M11.2009 18.289V16.4166C11.2027 16.1079 11.3255 15.8112 11.5425 15.5924L19.7863 7.34866C19.8958 7.23826 20.0261 7.15063 20.1696 7.09083C20.3132 7.03103 20.4671 7.00024 20.6226 7.00024C20.7781 7.00024 20.9321 7.03103 21.0756 7.09083C21.2192 7.15063 21.3494 7.23826 21.4589 7.34866L23.3192 9.20895C23.4299 9.31834 23.5177 9.44858 23.5776 9.59213C23.6375 9.73569 23.6684 9.88971 23.6684 10.0453C23.6684 10.2008 23.6375 10.3548 23.5776 10.4984C23.5177 10.642 23.4299 10.7722 23.3192 10.8816L15.0755 19.1254C14.8562 19.343 14.5602 19.4657 14.2513 19.467H12.3789C12.0665 19.467 11.7668 19.3429 11.5459 19.122C11.325 18.9011 11.2009 18.6015 11.2009 18.289Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.e5e90195298aa3b024b5285a7670d0ba.svg";
export { ForwardRef as ReactComponent };